import { atom } from 'recoil';

export const selectedWallet = atom({
  key: 'selectedWallet',
  default: undefined,
});
